import { ReactNode } from "react";
import styled from '@emotion/styled';
import { colors } from "src/theme";
import { MergeWithOverwrite } from "src/common";
import { LockIcon } from "../icons";

const LabelStyle = styled.label((props: { color: string, disabled: boolean }) => ({
  color: props.disabled ? colors.text4 : props.color,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '20px',
  marginBottom: '4px',
  display: 'inline-block',
  verticalAlign: 'top',
}));

const OptionalStyle = styled.span({
  color: colors.text4
});

export type InputLabelProps = MergeWithOverwrite<React.LabelHTMLAttributes<HTMLLabelElement>, {
  color?: string;
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  optional?: boolean;
}>;

export const InputLabel = ({ color = colors.text1, disabled = false, children, className, optional = false }: InputLabelProps) => (
  <LabelStyle color={color} disabled={disabled} className={className}>
    {children}
    {optional ? <OptionalStyle> (nije obavezno)</OptionalStyle> : null}
    {disabled ? <LockIcon width={12} height={12} color={colors.text4} /> : null}
  </LabelStyle>
);
